module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-all"
  }, [_c('v-classHeader', {
    attrs: {
      "type": _vm.headType.recommendMain
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "3rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recommend-main",
    attrs: {
      "id": "recommend"
    }
  }, _vm._l((_vm.recommends), function(recommend) {
    return _c('div', {
      staticClass: "recommend-item"
    }, [_c('div', {
      staticClass: "recommend-item-head",
      on: {
        "click": function($event) {
          _vm.goToRecommend(recommend)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": recommend.imgUrl
      }
    })]), _vm._v(" "), (recommend.pList && recommend.pList.length > 0) ? _c('v-recommend-swiper', {
      attrs: {
        "recommend": recommend,
        "type": _vm.headType.recommendMain
      }
    }, [_c('div', {
      staticClass: "recommend-more"
    }, [_vm._v("...")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]) : _c('div', {
      staticClass: "recommend-introduce"
    }, [_c('div', {
      staticClass: "recommend-introduce-left"
    }, [_vm._v(_vm._s(recommend.title))]), _vm._v(" "), _c('div', {
      staticClass: "recommend-introduce-right"
    }, [_vm._v("共" + _vm._s(recommend.total) + "件")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6587f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/RecommendHead.vue
// module id = 208
// module chunks = 2